import React, { useState, useEffect } from "react"
import { useShallow } from "zustand/react/shallow"
import { InputNumber, TextInput } from "components-design-system"
import Label from "components/Label/Label"
import { Flex } from "antd"
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

const RowTotalInput = (props) => {
  const { readOnly } = useAuthoringViewStore(useShallow((state) => ({ readOnly: state.readOnly })))
  let { measure, rowIndex, category, baselineData, setBaselineData } = props

  const handleValue = (e, key) => {
    let tempData = { ...baselineData }
    Object.keys(tempData).forEach((registry) => {
      let foundIndex = tempData[registry].baseline_measures.findIndex((item) => item.id === measure.id)
      if (foundIndex !== -1) {
        let foundCatIndex = tempData[registry].baseline_measures[foundIndex].rows[rowIndex].categories.findIndex(
          (item) => item.id === category.id
        )
        if (foundCatIndex !== -1) {
          let cat = tempData[registry].baseline_measures[foundIndex].rows[rowIndex].categories[foundCatIndex]
          if (cat.total) {
            cat.total[key] = e
          } else {
            cat.total = {
              [key]: e,
            }
          }
        }
      }
    })
    setBaselineData(tempData)
  }

  const getPercentage = () => {
    if (category?.values?.some((val) => val?.["value"] === "NA")) {
      return "NA%"
    }
    let percentage = "NA%"

    if (measure.parameter_type === "Count of Participants" || measure.parameter_type === "Count of Units") {
      let total = getTotalNumAnalyzedParticipants()

      if (measure?.rows?.[rowIndex]?.categories[0]?.values[0] && typeof category?.total?.value === "number") {
        percentage = (Number(category.total.value) / total) * 100
      }

      if (isNaN(percentage) || percentage === Infinity) percentage = "NA%"
    } else {
      percentage = "NA%"
    }

    return percentage === "NA%" ? percentage : `${percentage.toFixed(2)}%`
  }

  const getTotalNumAnalyzedParticipants = () => {
    if (props?.rows[0]?.categories[0]?.title === "Number Analyzed" && props?.rows[0]?.categories[0]?.values) {
      let key = measure.parameter_type === "Count of Units" ? "num_units_analyzed" : "value"

      let values = props?.rows[0]?.categories[0]?.values?.map((val) => {
        if (val?.[key]) return Number(val?.[key])
        return 0
      })
      return values.reduce((acc, val) => acc + Number(val), 0)
    }

    return 0
  }

  const getFields = () => {
    if (measure.parameter_type === "Count of Participants" || measure.parameter_type === "Count of Units") {
      const isNa = category?.values?.some((val) => val?.["value"] === "NA")

      return (
        <Flex vertical>
          {isNa ? (
            <TextInput
              label={measure.parameter_type}
              disabled={true}
              value={"NA"}
            />
          ) : (
            <InputNumber
              label={measure.parameter_type}
              disabled={true}
              readOnly={readOnly}
              onChange={(e) => handleValue(e, "value")}
              value={category?.total?.value}
            />
          )}
          <Label style={{ marginTop: 6 }}>{getPercentage()}</Label>
        </Flex>
      )
    } else if (measure.parameter_type === "Number") {
      return (
        <InputNumber
          label={measure.parameter_type}
          readOnly={readOnly}
          onChange={(e) => handleValue(e, "value")}
          value={category?.total?.value}
        />
      )
    } else if (measure.dispersion_type === "Standard Deviation") {
      return (
        <div className="field-container">
          <InputNumber
            label={measure.parameter_type}
            readOnly={readOnly}
            onChange={(e) => handleValue(e, "value")}
            value={category?.total?.value}
          />
          <InputNumber
            label={measure.dispersion_type}
            readOnly={readOnly}
            onChange={(e) => handleValue(e, "dispersion_value")}
            value={category?.total?.dispersion_value}
          />
        </div>
      )
    } else if (measure.dispersion_type === "Inter-Quartile Range" || measure.dispersion_type === "Full Range") {
      return (
        <div className="field-container">
          <InputNumber
            label={measure.parameter_type}
            readOnly={readOnly}
            onChange={(e) => handleValue(e, "value")}
            value={category?.total?.value}
          />
          <div className="range-container">
            <Label style={{ marginBottom: ".3rem", width: "100%" }}>{measure.dispersion_type}</Label>
            <div className="field-items">
              <InputNumber
                readOnly={readOnly}
                onChange={(e) => handleValue(e, "dispersion_value")}
                value={category?.total?.dispersion_value}
              />
              <Label style={{ marginBottom: 6 }}>to</Label>
              <InputNumber
                readOnly={readOnly}
                onChange={(e) => handleValue(e, "dispersion_value_upper_bound")}
                value={category?.total?.dispersion_value_upper_bound}
              />
            </div>
          </div>
        </div>
      )
    }
  }

  return <td className="total-col text-left">{getFields()}</td>
}

export default RowTotalInput
